const menus = [
  {
    title: '부위별운동',
    path: '/parts',
  },
  {
    title: '루틴',
    path: '/challenges',
  },
  {
    title: '정산',
    path: '/cash',
  },
  {
    title: '코치',
    path: '/coach',
  },
  {
    title: '공지사항',
    path: '/notice',
  },
  // {
  //   title: '루틴 등록',
  //   path: '/challenge/new',
  // },
  {
    title: '로그아웃',
    path: '/auth/logout',
  },
];

export default menus;
